import { library } from '@fortawesome/fontawesome-svg-core';
import { faEdit, faUnlink } from '@fortawesome/free-solid-svg-icons';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Card } from '../../../../design/card/card/S_Cards';
import { S_Pagination } from '../../../../design/pagination/S_Pagination';
import { Thumbnails } from '../../../../design/thumbnails/Thumbnails';
import { Loader } from '../../../components/Loader';
import { scrollTop } from '../../../helpers/react.helpers';
import { IAttachment } from '../attachments.store';
import { AttachmentThumbnail } from './AttachmentThumbnail';

library.add(faUnlink, faEdit);

export interface IAttachmentsListThumbsProps {
  attachments: IAttachment[];
  authToken: string;
  isLoading: boolean;
  workspaceId: string;
  selectedAttachments: {
    ids: string[];
    isAllSelected: boolean;
  };
  pagination: {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
  };
  onPaginationChange: (pageNumber: number, pageSize: number) => Promise<void>;
  onThumbCheck: (id: string, isBatch: boolean) => void;
  onFileDownload: (id: string) => Promise<void>;
  onThumbDelete: (id: string) => void;
  getThumbnailUrl: (id: string) => string;
}

export const AttachmentsListThumbs = observer((props: IAttachmentsListThumbsProps): ReactElement => {
  const handlePaginationChange = async (pageNumber: number, pageSize: number): Promise<void> => {
    scrollTop();
    await props.onPaginationChange(pageNumber, pageSize);
  };

  return (
    <S_Card className='details-attachment-list'>
      <Loader isLoading={props.isLoading}>
        <div className='details-attachment-list-content'>
          <Thumbnails isLoading={props.isLoading}>
            {!props.isLoading &&
              props.attachments.map((attachment: IAttachment) => {
                return (
                  <AttachmentThumbnail
                    key={attachment.id}
                    attachment={attachment}
                    authToken={props.authToken}
                    isChecked={
                      props.selectedAttachments.isAllSelected
                        ? !props.selectedAttachments.ids.includes(attachment.id)
                        : props.selectedAttachments.ids.includes(attachment.id)
                    }
                    workspaceId={props.workspaceId}
                    onCheck={props.onThumbCheck}
                    onFileDownload={props.onFileDownload}
                    onDelete={props.onThumbDelete}
                    getThumbnailUrl={props.getThumbnailUrl}
                  />
                );
              })}
          </Thumbnails>
          <S_Pagination
            pageNumber={props.pagination.pageNumber}
            pageSize={props.pagination.pageSize}
            totalCount={props.pagination.totalCount}
            onChange={handlePaginationChange}
            pageSizeLabel='pagination.showImages'
          />
        </div>
      </Loader>
    </S_Card>
  );
});
